import { Stack, Typography } from '@mui/material';
import { InfoRounded } from '@mui/icons-material';

interface FeedbackSummaryInfoMessageProps {
  hasSummary: boolean;
}

const FeedbackSummaryInfoMessage = ({
  hasSummary,
}: FeedbackSummaryInfoMessageProps) => {
  return (
    <Stack spacing={1} direction="row" alignItems="center" padding={2}>
      <InfoRounded sx={{ color: 'text.secondary' }} fontSize="small" />
      <Typography variant="body2" color="text.secondary">
        {hasSummary
          ? 'Select a tracked keyword or reason to view the summary'
          : 'No predictions found, summary not generated'}
      </Typography>
    </Stack>
  );
};

export default FeedbackSummaryInfoMessage;
